module.exports = __webpack_public_path__ + "static/media/麦克纳姆轮机械车.55ca31ad.png";